var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarChatCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.40002 7.19999C2.40002 5.8745 3.47454 4.79999 4.80002 4.79999H12C13.3255 4.79999 14.4 5.8745 14.4 7.19999V16.8C14.4 18.1255 13.3255 19.2 12 19.2H4.80002C3.47454 19.2 2.40002 18.1255 2.40002 16.8V7.19999Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4634 8.52668C17.0568 8.72995 16.8 9.14546 16.8 9.59999V14.4C16.8 14.8545 17.0568 15.27 17.4634 15.4733L19.8634 16.6733C20.2354 16.8593 20.6771 16.8394 21.0309 16.6208C21.3847 16.4021 21.6 16.0159 21.6 15.6V8.39999C21.6 7.9841 21.3847 7.59786 21.0309 7.37921C20.6771 7.16056 20.2354 7.14068 19.8634 7.32668L17.4634 8.52668Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarChatCameraIcon);
export default __webpack_public_path__ + "static/media/avatar_chat_camera_icon.52087fd85da13832145ceb849244161f.svg";
export { ForwardRef as ReactComponent };